<template>
  <span v-if="!useLexicon"
        :class="customStyling ? '' : 'text'"
        :style="customStyling ? customStyling : ''">
    {{ value }}
  </span>

  <fin-lexicon-text v-else
                    :class="customStyling ? '' : 'd-inline text'"
                    :style="customStyling ? customStyling : ''"
                    :text="value"
                    auto-solve/>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  name: "TextCell",
  components: {FinLexiconText},
  props: {
    /** The text to display */
    value: {},
    /** Either display the plain text or use the fin-lexicon-text component with auto-solve */
    useLexicon: {
      type: Boolean,
      default: false
    },
    /** Use custom css styles instead of the default one */
    customCssStyle: {
      type: String
    },
    header: {},
  },
  computed: {
    customStyling() {
      return this.customCssStyle || this.header?.componentProps.customStyling
    },
  },
}
</script>

<style lang="scss" scoped>
.text {
  font-size: 16px !important;
  line-height: 1.38;
  font-weight: bold;
  font-family: $body-font-family !important;

  @media only screen and (max-width: 600px) {
    font-size: 13px !important;
  }
}
</style>
